'use client';

import { useState } from 'react';
import HeroSection from './HeroSection';
import DataCollectionSection from './DataCollectionSection';
import DataUsageSection from './DataUsageSection';
import CookiePolicySection from './CookiePolicySection';
import GuestRightsSection from './GuestRightsSection';
import ThirdPartySection from './ThirdPartySection';

export default function PrivacyPolicyInteractive() {
  const [expandedSection, setExpandedSection] = useState<string | null>(null);

  const toggleSection = (sectionId: string) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  return (
    <div className="min-h-screen">
      <HeroSection />
      <DataCollectionSection 
        isExpanded={expandedSection === 'data-collection'}
        onToggle={() => toggleSection('data-collection')}
      />
      <DataUsageSection 
        isExpanded={expandedSection === 'data-usage'}
        onToggle={() => toggleSection('data-usage')}
      />
      <CookiePolicySection 
        isExpanded={expandedSection === 'cookie-policy'}
        onToggle={() => toggleSection('cookie-policy')}
      />
      <GuestRightsSection 
        isExpanded={expandedSection === 'guest-rights'}
        onToggle={() => toggleSection('guest-rights')}
      />
      <ThirdPartySection 
        isExpanded={expandedSection === 'third-party'}
        onToggle={() => toggleSection('third-party')}
      />
    </div>
  );
}